import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeferredErrorVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeferredErrorVO.validationSchema()
  );

  constructor(readonly value: RoomBrandOverlayDeferredError) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayDeferredErrorVO.validation,
      value
    );
  }

  toString() {
    return `${this.value.message} (${this.value.code}, ${this.value.errorId})`;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["code", "message"],
      properties: {
        code: {
          type: "number",
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER
        },
        message: {
          type: "string",
          minLength: 0,
          maxLength: 2_048
        },
        errorId: {
          type: "string",
          format: "uuid"
        }
      }
    };
  }
}

interface RoomBrandOverlayDeferredError {
  code: number;
  message: string;
  errorId?: string;
}
